<template>
    <div>
        <div class="title">
            <Breadcrumb>
                <BreadcrumbItem to="/ticketCenter/case">{{$t('ticket.list.ticket')}}</BreadcrumbItem>
                <BreadcrumbItem>{{ticketEntityId}}</BreadcrumbItem>
            </Breadcrumb>
            <Button type="primary" @click="exportContent()" style="float:right;margin-top:-25px;" v-hasPermission="['cases:caseDetail:export']">{{ $t('ticket.list.export') }}</Button>
        </div>
        <Row :gutter="10" style="margin-bottom:10px;">
            <Col span="24">
                <Button type="primary" @click="commentModal = true" v-hasPermission="['cases:caseDetail:comment']">{{ $t('ticket.list.comment') }}</Button>
                <Button type="primary" v-if="this.ticketCategorys==7&&this.functionType==23&&this.statuss==8&&(currentUser=='andywei'||currentUser=='geralguo')" @click="confirmTicketContent">确认</Button>
                <!-- RI 续购操作按钮：根据后端返回字段控制显示 -->
                <Button v-if="showConfirmRenewalBtn" type="success" @click="openConfirmRiRenewModal">确认续购</Button>
                <Button v-if="showRejectRenewalBtn" type="warning" @click="openRejectRiRenewModal">无需续购</Button>
                <Button v-if="showPurchaseConfirmBtn" type="info" @click="confirmPurchase">购买确认</Button>
                <Button @click="returnGo" v-hasPermission="['cases:caseDetail:return']">{{ $t('ticket.list.return') }}</Button>
            </Col>
        </Row>

        <Form :label-width="100" label-position="left">
            <!-- 案例详情 -->
            <Row :gutter="10" style="margin-bottom: 10px;">
                <Col span="16">
                    <Card style="min-height:300px;">
                        <p slot="title" style="line-height:16px;font-size:13px;color:#000;height: 15px;">{{$t('ticket.list.ticketDetail')}}</p>
                        <div style="padding-left:14px;">
                            <Row>
                                <Col>
                                    <!-- 案例ID -->
                                    <FormItem :label="$t('ticket.list.ticketEntityID')">{{ticketEntityId}}</FormItem>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <!-- 概要 -->
                                    <FormItem :label="$t('ticket.list.subject')">{{subject}}</FormItem>
                                </Col>
                            </Row>
                            <Divider dashed />
                            <Row>
                                <Col>
                                    <!-- 问题类型 -->
                                    <FormItem :label="$t('ticket.list.category')">{{ticketCategory}}</FormItem>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <!-- 优先级 -->
                                    <FormItem :label="$t('ticket.list.level')">{{priorityId}}</FormItem>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <!-- 状态 -->
                                    <FormItem :label="$t('satisfaction.status')">
                                        <Select v-model="status" filterable style="width:300px;" placeholder=" ">
                                            <Option :value="0">{{ $t('ticket.list.Pending') }}</Option>
                                            <Option :value="1">{{ $t('ticket.list.Processing') }}</Option>
                                            <Option :value="2">{{ $t('ticket.list.Finish') }}</Option>
                                            <Option :value="3">{{ $t('ticket.list.WaitingForTheAuthorization') }}</Option>
                                            <Option :value="4" disabled>{{ $t('ticket.list.CheckNozzle') }}</Option>
                                            <Option :value="5">{{ $t('ticket.list.UnderReview') }}</Option>
                                            <Option :value="6">{{ $t('ticket.list.TheAuditFails') }}</Option>
                                            <Option :value="7">{{ $t('ticket.list.Approved') }}</Option>
                                            <Option :value="8">{{ $t('ticket.list.Confirming') }}</Option>
                                            <Option :value="9">{{ $t('ticket.list.Confirmed') }}</Option>
                                        </Select>
                                        <Button @click="update">{{$t('ticket.list.updateStatus')}}</Button>
                                    </FormItem>
                                </Col>
                            </Row>
                        </div>
                    </Card>
                </Col>
                <Col span="8">
                    <Row style="margin-bottom:10px;">
                        <Col>
                            <Card>
                                <p slot="title" style="line-height:16px;font-size:13px;color:#000;height: 15px;">{{$t('ticket.list.personnel')}}</p>
                                <div style="padding-left:14px;">
                                    <Row>
                                        <Col>
                                            <!-- 经办人 -->
                                            <FormItem :label="$t('ticket.list.assignee')">{{assigneeUserName}}</FormItem>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <!-- 报告人 -->
                                            <FormItem :label="$t('ticket.list.reporter')">{{reporterUserName}}</FormItem>
                                        </Col>
                                    </Row>
                                </div>
                            </Card>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Card>
                                <p slot="title" style="line-height:16px;font-size:13px;color:#000;height: 15px;">{{$t('ticket.list.date')}}</p>
                                <div style="padding-left:14px;">
                                    <Row>
                                        <Col>
                                            <!-- 创建日期 -->
                                            <FormItem :label="$t('ticket.list.createdDate')">{{createdTime}}</FormItem>
                                        </Col>
                                        <Col>
                                            <!-- 更新日期 -->
                                            <FormItem :label="$t('ticket.list.modifiedDate')">{{modifiedTime}}</FormItem>
                                        </Col>
                                    </Row>
                                </div>
                            </Card>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <!-- 描述 -->
            <Row :gutter="10" style="margin-bottom: 10px;">
                <Col span="24">
                    <Card>
                        <p slot="title" style="line-height:16px;font-size:13px;color:#000;height: 15px;">{{$t('ticket.list.description')}}</p>
                        <Row style="padding-left:14px;font-size:13px;">
                            <Col v-html="descriptionData[0].describe"></Col>
                        </Row>
                    </Card>
                </Col>
            </Row>
            <!-- 列表 -->
            <Row :gutter="10" style="margin-bottom: 10px;">
                <Col span="24">
                    <Card>
                        <p slot="title" style="line-height:16px;font-size:13px;color:#000;height: 15px;">{{ $t('ticket.list.list') }}</p>
                        <Tabs size="small" :animated="false" style="padding-left:14px;">
                            <TabPane :label="$t('ticket.comment.comment')" class="tap">
                                <div class="comment-content" v-show="isNullData">{{$t('common.noData')}}</div>
                                <div class="comment-content" v-for="content in commentList">
                                    <div>{{content.createdBy}} {{ $t('ticket.list.addedComments') }} - {{content.createdTime}}</div>
                                    <div>{{content.comment}}</div>
                                </div>
                            </TabPane>
                            <TabPane :label="$t('ticket.comment.changeRecord')">
                                <template>
                                    <Table :no-data-text="$t('common.noData')" border :columns="columns" :data="logData" :border="false"></Table>
                                </template>
                            </TabPane>
                            <TabPane :label="$t('ticket.comment.attachmentList')">
                                <template>
                                    <Table :no-data-text="$t('common.noData')" border :columns="columnsFile" :data="fileData" :border="false">
                                        <!-- 下载 -->
                                        <template slot-scope="{row,index}" slot="download">
                                            <span @click="downloadIndex(index)">
                                                <Button type="success" size="small" @click="downloadModal= true" v-hasPermission="['cases:caseDetail:download']">下载</Button>
                                            </span>
                                        </template>
                                    </Table>
                                </template>
                            </TabPane>
                        </Tabs>
                    </Card>
                </Col>
            </Row>
        </Form>

        <!-- 评论模式框 -->
        <Modal v-model="commentModal" :title="$t('ticket.comment.addComments')" :loading="loading" @on-ok="commentSubmit('commentForm')" @on-cancel="commentReset('commentForm')" :mask-closable="false" :okText="$t('alarms.common.add')" :cancelText="$t('alarms.common.cancel')">
            <Form ref="commentForm" :model="commentForm" :label-width="100" :rules="ruleValidate">
                <!-- 案例ID -->
                <FormItem :label="$t('KPI.ticketEntityId')" prop="ticketEntityId" >
                    <div>{{ticketEntityId}}</div>
                </FormItem>

                <!-- 评论 -->
                <FormItem :label="$t('ticket.comment.comment')" prop="comment">
                    <Input v-model="commentForm.comment" type="textarea" :autosize="{minRows: 6,maxRows: 18}" placeholder="" style="width:300px;"></Input>
                </FormItem>
            </Form>
        </Modal>
        <!-- 下载附件模式框 -->
        <Modal v-model="downloadModal" width="360" :mask-closable="false" :styles="{top:'250px'}">
            <p slot="header" style="color:#19be6b;text-align:center">
                <Icon type="ios-information-circle"></Icon>
                <span>{{ $t('ticket.list.affirmDownload') }}</span>
            </p>
            <div style="text-align:center">
                <p>{{ $t('ticket.comment.confirmDownload') }} {{fileName}} {{ $t('ticket.comment.what') }}?</p>
            </div>
            <div slot="footer">
                <Button type="success" size="large" long :loading="modal_loading" @click="downloadFile()" :disabled="isDisable">{{ $t('ticket.comment.download') }}</Button>
            </div>
        </Modal>
        <!-- 确认续购弹框 -->
        <Modal v-model="confirmRiRenewModal" title="确认续购" :mask-closable="false" @on-ok="submitConfirmRiRenew" @on-cancel="resetConfirmRiRenewForm" :loading="confirmRiRenewLoading" okText="确认" cancelText="取消">
            <Form ref="confirmRiRenewForm" :model="confirmRiRenewForm" :rules="confirmRiRenewRules" :label-width="100">
                <FormItem label="工单编号">
                    <div>{{ ticketEntityId }}</div>
                </FormItem>
                <FormItem label="分配给：" prop="assigneeUserId">
                    <Select v-model="confirmRiRenewForm.assigneeUserId" filterable placeholder="请选择" :transfer="true" style="width: 100%;">
                        <Option v-for="item in riRenewAssigneeList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </FormItem>
            </Form>
        </Modal>
        <!-- 无需续购弹框 -->
        <Modal v-model="rejectRiRenewModal" title="无需续购" :mask-closable="false" @on-ok="submitRejectRiRenew" :loading="rejectRiRenewLoading" okText="确认" cancelText="取消">
            <p>确认提交"无需续购"结论吗？该操作会在工单中生成标准评论 "客户已确认无需续购 RI"，AI 识别后将取消未完成的 RI 续购任务并关闭当前工单。</p>
        </Modal>
    </div>
</template>

<script>
    import utils from '../../../utils/utils.js'
    import {setCookie,getCookie} from '../../../utils/cookieUtil.js'
    export default {
        name: 'CaseDetail',
        data(){
            return {
                currentUser:getCookie(global.cookieName),
                ticketCategorys:'',
                functionType:'',
                statuss:'',
                reporterUserName:'',
                ticketEntityId:'',
                subject:'',
                ticketCategory:'',
                status:null,
                priorityId:'',
                description:'',
                createdTime:'',
                modifiedTime:'',
                assigneeUserName:'',
                commentModal:false,
                loading: true,
                isNullData:false,
                downloadModal:false,
                isDisable: false,
                modal_loading: false,
                fileName:'',
                commentForm: {
                    comment: ''
                },
                ruleValidate: {
                    comment: [
                        { required: true, message: this.$t('ticket.comment.pleaseEnterDescription'), trigger: 'blur'},
                        { type: 'string', max: 10000, message: '最多输入10000个字符', trigger: 'blur' }
                    ]
                },
                commentList:[],
                columns: [
                    {
                        title: this.$t('ticket.comment.responsiblePerson'),
                        key: 'createdBy'
                    },
                    {
                        title: this.$t('ticket.comment.operationType'),
                        key: 'operationType'
                    },
                    {
                        title: this.$t('ticket.comment.originValue'),
                        key: 'operationOriginValue'
                    },
                    {
                        title: this.$t('ticket.comment.newValue'),
                        key: 'operationNewValue'
                    },
                    {
                        title: this.$t('ticket.comment.description'),
                        key: 'description'
                    },
                    {
                        title: this.$t('ticket.comment.updateTime'),
                        key: 'createdTime'
                    }
                ],
                columnsFile: [
                    {
                        title: this.$t('ticket.comment.fileName'),
                        key: 'fileName'
                    },
                    {
                        title: this.$t('ticket.comment.fileName'),
                        key: 'fileType'
                    },
                    {
                        title: this.$t('ticket.comment.storagePath'),
                        key: 'storagePath'
                    },
                    {
                        title: this.$t('common.operation'),
                        slot: 'download',
                        "width": 100
                    }
                ],
                descriptionData:[{"describe":''}],
                logData: [],
                fileData:[],
                // RI 续购相关
                showConfirmRenewalBtn: false,
                showRejectRenewalBtn: false,
                showPurchaseConfirmBtn: false,
                confirmRiRenewModal: false,
                rejectRiRenewModal: false,
                confirmRiRenewLoading: true,
                rejectRiRenewLoading: true,
                riRenewAssigneeList: [],
                confirmRiRenewForm: {
                    assigneeUserId: ''
                },
                confirmRiRenewRules: {
                    assigneeUserId: [
                        { required: true, type: 'number', message: '请选择分配人', trigger: 'change' }
                    ]
                }
            }
        },
        computed: {
        },
        mounted: function(){
            this.init();
        },
        methods: {
            // 返回上一页
            returnGo:function(){
                this.$router.push({path:'/ticketCenter/case/'});
            },
            // 详情
            init: function(){
                this.id=this.$route.query.id;
                // 获取详情数据
                this.$api.ticket.selectTicket("id",this.id)
                .then(res => {
                    // 案例ID
                    this.ticketEntityId=res.data.ticketEntityId;
                    // 概要
                    this.subject=res.data.subject;
                    // 类型
                    this.ticketCategory=res.data.ticketCategoryName;
                    // 状态
                    this.status=res.data.status;
                    // 优先级
                    this.priorityId=res.data.priorityName;
                    // 经办人
                    this.assigneeUserName=res.data.assigneeUserName;
                    // 报告人
                    this.reporterUserName=res.data.reporterUserName;
                    // 描述
                    if(res.data.description){
                        this.description=res.data.description;
                        this.descriptionData[0].describe=this.description;
                    }
                    // 创建日期
                    this.createdTime=res.data.createdTime;
                    // 更新日期
                    this.modifiedTime=res.data.modifiedTime;
                    // 案例类型
                    this.ticketCategorys=res.data.ticketCategory;
                    // 功能类型
                    this.functionType=res.data.functionType;
                    // 案例状态
                    this.statuss=res.data.status;
                    // RI 续购按钮显示控制（后端返回）
                    this.showConfirmRenewalBtn = res.data.showConfirmRenewalBtn || false;
                    this.showRejectRenewalBtn = res.data.showRejectRenewalBtn || false;
                    this.showPurchaseConfirmBtn = res.data.showPurchaseConfirmBtn || false;

                    // 操作日志模块
                    /*******************************************************************/
                    this.$api.ticket.operationLog("id",this.id)
                    .then(res => {
                        this.logData = res.data;
                    })

                    // 查询评论模块
                    /*******************************************************************/
                    this.$api.comment.queryCommentsByTicketEntityId("ticketEntityId",this.ticketEntityId)
                    .then(res => {
                        this.commentList = res.data;
                        // 暂无数据
                        if(this.commentList.length==0){
                            this.isNullData=true;
                        }else{
                            this.isNullData=false;
                        }
                    })

                    // 显示附件列表
                    /*******************************************************************/
                    this.$api.attatchment.selectByTicketId("id",this.id)
                    .then(res => {
                        this.fileData=res.data;
                    })
                })

            },
            // 点击确认
            confirmTicketContent:function(){
                // 获取详情数据
                this.$api.ticket.confirmTicket("id",this.$route.query.id)
                .then(res => {
                })
            },
            // 下载附件
            /*******************************************************************/
            downloadIndex: function(index){
                this.lineIndex=index;
                this.fileName=this.fileData[index].fileName;
            },
            downloadFile: function(){
                this.isDisable = true;  //开始可以点击
                var lineIndex=this.lineIndex;
                // 下载附件
                this.$api.file.downloadFile("id",this.fileData[lineIndex].id)
                .then(res => {
                    let aTag = document.createElement('a');
                    let blob = new Blob([res.data],{type: 'text/plain;charset=UTF-8'})
                    aTag.download = this.fileData[lineIndex].fileName;　　　　　　// 下载的文件名
                    aTag.href = URL.createObjectURL(blob);
                    aTag.click();　　　　　　　　　　　　　　
                    URL.revokeObjectURL(blob);
                    this.modal_loading = true;
                    setTimeout(() => {
                        this.isDisable = false;
                        this.modal_loading = false;
                        this.downloadModal = false;
                        this.$Message.success('Success');
                    }, 1000);
                })
            },
            // 评论模块
            /*******************************************************************/
            // 确定
            commentSubmit: function(name){
                this.$refs[name].validate(valid => {
                    if(valid){
                        // 添加评论
                        this.$api.comment.createComment({
                            "ticketEntityId":this.ticketEntityId,
                            "comment":this.commentForm.comment
                        })
                        .then(res => {
                            this.data = res.data;
                            setTimeout(() => {
                                this.init();
                                this.$refs[name].resetFields();
                                this.loading = false;
                                this.$nextTick(() => {
                                    this.loading = true;
                                });
                                this.$Message.success('Success');
                                this.commentModal = false;
                            },1000);
                        })
                    }else{
                        //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
                        this.loading = false;
                        setTimeout(() => {
                            this.loading = true
                        }, 0)
                        this.$Message.error('添加失败');
                    }
                });
            },
            // 取消
            commentReset: function(name){
                this.$refs[name].resetFields();
            },
            // 导出
            /*******************************************************************/
            exportContent:function(){
                this.id=this.$route.query.id;
                this.$api.ticket.export("id",this.id)
                .then(res => {
                    let fileName = 'TicketTask.xlsx'
                    let blob = new Blob([res.data], {type: 'application/x-xlsx'})
                    if (window.navigator.msSaveOrOpenBlob) {
                      navigator.msSaveBlob(blob, fileName);
                    } else {
                      var link = document.createElement('a');
                      link.href = window.URL.createObjectURL(blob);
                      link.download = fileName;
                      link.click();
                      window.URL.revokeObjectURL(link.href);
                    }
                    this.$Message.destroy();
                    this.$Message.success('Success');
                })
            },
            // 更新状态
            update:function(){
                // 编辑案例
                this.$api.ticket.updateTicket({
                    "id":this.$route.query.id,
                    "status":this.status,
                    "isTicketNotNull": false
                })
                .then(res => {
                    this.$Message.success('编辑成功');
                    this.init();
                })
            },
            // ============ RI 续购相关 ============
            // 加载分配人下拉列表（沿用经办人接口 /sme/user/selectAgent）
            loadRiRenewAssigneeList: function() {
                this.$api.user.selectAgent('userName', getCookie(global.cookieName))
                    .then(res => {
                        var list = (res && res.data) || [];
                        if (Array.isArray(list)) {
                            this.riRenewAssigneeList = list;
                        } else if (list.data && Array.isArray(list.data)) {
                            this.riRenewAssigneeList = list.data;
                        } else {
                            this.riRenewAssigneeList = [];
                        }
                    })
                    .catch(() => {
                        this.riRenewAssigneeList = [];
                    });
            },
            // 打开"确认续购"弹框
            openConfirmRiRenewModal: function() {
                this.confirmRiRenewForm = {
                    assigneeUserId: ''
                };
                this.loadRiRenewAssigneeList();
                this.confirmRiRenewModal = true;
            },
            // 打开"无需续购"弹框
            openRejectRiRenewModal: function() {
                this.rejectRiRenewModal = true;
            },
            // 重置确认续购表单
            resetConfirmRiRenewForm: function() {
                if (this.$refs.confirmRiRenewForm) {
                    this.$refs.confirmRiRenewForm.resetFields();
                }
            },
            // 提交确认续购
            submitConfirmRiRenew: function() {
                this.$refs.confirmRiRenewForm.validate(valid => {
                    if (!valid) {
                        // iview 关闭确认按钮 loading
                        this.confirmRiRenewLoading = false;
                        this.$nextTick(() => { this.confirmRiRenewLoading = true; });
                        this.$Message.error('请选择分配人');
                        return;
                    }
                    // 按对接文档 2.1：仅传 ticketEntityId 和 assigneeUserId
                    this.$api.ticket.confirmRiRenew({
                        ticketEntityId: this.ticketEntityId,
                        assigneeUserId: this.confirmRiRenewForm.assigneeUserId
                    }).then(res => {
                        var data = (res && res.data) || {};
                        if (data.code != null && data.code !== 200) {
                            this.$Message.error(data.message || '提交失败');
                            this.confirmRiRenewLoading = false;
                            this.$nextTick(() => { this.confirmRiRenewLoading = true; });
                            return;
                        }
                        this.$Message.success('已提交确认续购');
                        this.confirmRiRenewModal = false;
                        this.init();
                    }).catch(() => {
                        this.confirmRiRenewLoading = false;
                        this.$nextTick(() => { this.confirmRiRenewLoading = true; });
                    });
                });
                // 取消默认关闭，由 API 成功回调控制
                this.confirmRiRenewLoading = false;
                this.$nextTick(() => { this.confirmRiRenewLoading = true; });
            },
            // 提交无需续购
            submitRejectRiRenew: function() {
                // 按对接文档 2.2：仅传 ticketEntityId
                this.$api.ticket.rejectRiRenew({
                    ticketEntityId: this.ticketEntityId
                }).then(res => {
                    var data = (res && res.data) || {};
                    if (data.code != null && data.code !== 200) {
                        this.$Message.error(data.message || '提交失败');
                        this.rejectRiRenewLoading = false;
                        this.$nextTick(() => { this.rejectRiRenewLoading = true; });
                        return;
                    }
                    this.$Message.success('已提交无需续购');
                    this.rejectRiRenewModal = false;
                    this.init();
                }).catch(() => {
                    this.rejectRiRenewLoading = false;
                    this.$nextTick(() => { this.rejectRiRenewLoading = true; });
                });
            },
            // 购买确认（二线确认）
            confirmPurchase: function() {
                this.$Modal.confirm({
                    title: '购买确认',
                    content: '确认已完成 RI 购买操作吗？',
                    onOk: () => {
                        this.$api.ticket.purchaseConfirm(this.ticketEntityId).then(res => {
                            var data = (res && res.data) || {};
                            if (data.code != null && data.code !== 200) {
                                this.$Message.error(data.message || '确认失败');
                                return;
                            }
                            this.$Message.success('购买确认成功');
                            this.init();
                        }).catch(() => {
                            this.$Message.error('请求失败');
                        });
                    }
                });
            }
        }
    }
</script>

<style scoped>
    .comment-content{
        background-color: #fff;
        padding-left: 14px;
        padding-bottom: 14px;
        font-size: 12px;
        line-height: 22px;
        margin-top: 3px;
    }
    .title
    {
        width: 100%;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 8px 4px;
    }
    .ivu-breadcrumb {
        font-size: 13px;
        font-weight: 600;
        color: #515a6e;
    }
    .ivu-form-item {
        margin-bottom: 0px !important;
        vertical-align: top;
        zoom: 1;
    }
</style>



// WEBPACK FOOTER //
// src/components/cases/case/CaseDetail.vue